<template>
  <div>
      <div class="statusview" :style="{height: state.statusHeight + 'px'}"></div>
      <div class="iosTop"></div>
  </div>
   
</template>

<script setup>
import { onMounted, reactive } from 'vue';

const state = reactive({
  statusHeight: 0,
});

onMounted(() => {
  try {
    state.statusHeight = window.JsBridge.getStatusBarHeight();
  } catch (error) {
    state.statusHeight = 0;
    // state.statusHeight = window.screen.height - window.innerHeight;
  }
  
})

</script>

<style scoped="scoped">
.iosTop {
  height: constant(safe-area-inset-top);
  height: env(safe-area-inset-top);
}

</style>